export default __webpack_public_path__ + "static/media/gallery_08.7b7e4634.jpg";